import React from 'react'
import { makeStyles, Grid, Paper, Box, fade, Card, CardActionArea, CardContent, CardMedia, Button, Typography, InputBase, Container } from '@material-ui/core';
import { Link } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';
import ScrollAnimation from 'react-animate-on-scroll';
import { GetCitiesOfState } from '../../data/utils/index'


const useStyles = makeStyles((theme) => ({
    rootsInput: {
        flexGrow: 1,
        alignItems: "center"

    },

    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.50),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 1),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        [theme.breakpoints.up('sm')]: {
            width: '50ch',
            '&:focus': {
                width: '50ch',
            },
        },
    },
    root: {
        maxWidth: 345,
        textDecoration: "none"
    },
    box: {
        overflow: "hidden",
        position: "relative",
        '&::after': {
            content: '""',
            backgroundColor: "rgba(2, 18, 102, 0.7)",
            border: "2px solid transparent",
            opacity: 0,
            transform: "rotate(360deg) scale(0.5)",
            transformOrigin: "right bottom",
            position: "absolute",
            left: "20px",
            top: "20px",
            bottom: "20px",
            right: "20px",
            transition: "all .3s ease",
        },
        '&:hover': {
            '&:after': {
                borderColor: "rgba(255,255,255,0.9)",
                boxShadow: "0 0 30px rgba(0,0,0,0.9)",
                opacity: 1,
                transform: "rotate(0) scale(1)",
            },
            "& :nth-child(1)": {
                opacity: 0.9,
                transform: "scale(1.5) translateY(-12px)",
            },
            "& :nth-child(2)": {
                opacity: 1,
                bottom: "40px",
            },
            '& :nth-child(3)>li': {
                opacity: 1,
                transform: "translateY(0)",
            },
            '& :nth-child(3)>li:nth-child(1)': {
                transitionDelay: "0.3s",
            },
            '& :nth-child(3)>li:nth-child(2)': {
                transitionDelay: "0.4s",
            },
        }
    },
    img: {
        width: "100%",
        height: '15rem',
        transform: "scale(1) translateY(0)",
        transition: "all .4s ease-in-out",
    },
    boxContent: {
        color: "#fff",
        textAlign: "center",
        width: "100%",
        opacity: 0,
        transform: "translateX(-50%)",
        position: "absolute",
        bottom: "25px",
        left: "50%",
        zIndex: 1,
        transition: "all .3s ease 0.2s",
    },
    title: {
        fontSize: "12px",
        fontWeight: 700,
        textTransform: "uppercase",
        textShadow: "0 0 3px #FF0000, 0 0 5px #0000FF",
        margin: 0,
    },
    post: {
        fontSize: "16px",
        fontStyle: "italic",
        textTransform: "capitalize",
        letterSpacing: "1px",
        textShadow: "0 0 3px #FF0000, 0 0 5px #0000FF",
    },
    icon: {
        padding: 0,
        margin: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-around",
        listStyle: "none",
        transform: "translateX(-50%)",
        position: "absolute",
        width: "100%",
        top: "55px",
        left: "50%",
        zIndex: 1,
    },
    li: {
        margin: "8px 0",
        display: "inline-block",
        opacity: 0,
        transform: "translateY(-50%)",
        transition: "all 0.3s ease",
    },
    a: {
        color: "#fff",
        fontSize: "12px",
        textAlign: "center",
        textDecoration: "none",
        position: "relative",
        textShadow: "0 0 3px #FF0000, 0 0 5px #0000FF",
        transition: "all 0.3s ease",
        display: "block",

        '&:hover': {
            color: "#fff",
            textShadow: "0 0 0 2px #fff",
        }
    },
    LoadMoreCities: {
        marginTop: "2rem",
        display: "flex",
        justifyContent: "center"
    },
    loadMorebtn: {
        color: 'white',
        fontFamily: "Bangers,cursive",
        letterSpacing: 5,
        background: "radial-gradient(circle, rgba(255,88,5,1) 0%, rgba(7,23,142,1) 100%)",
        '&:hover': {
            boxShadow: "1px 1px 25px 10px rgba(146, 148, 248, 0.4)"
        }
    }
}));

function Cards({ states }) {
    const classes = useStyles();
    const [searchItem, setSearch] = React.useState('')
    const [visible, setVisible] = React.useState(5)

    const LoadMoreStateHandler = () => {
        setVisible(visible + 5)
    }

    return (
        <>
            <Grid style={{ margin: "auto", width: "80%" }}>
                <Box className={classes.rootsInput}>

                    <Box className={classes.search}>
                        <Box className={classes.searchIcon}>
                            <SearchIcon />
                        </Box>
                        <InputBase
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search…"
                            classes={{
                                rootsInput: classes.inputRoot,
                                input: classes.inputInput,
                            }}
                            inputProps={{ 'aria-label': 'search' }}
                        />
                    </Box>

                </Box>
            </Grid>
            <br />
            <Grid container spacing={2}>

                {
                    states.slice(0, visible).filter((ite, i) => {
                        if (searchItem == "") {
                            return ite
                        } else if (ite.name.toLowerCase().includes(searchItem.toLowerCase())) {
                            return ite
                        }
                    })
                        .map((item, i) =>
                            <Grid item xs={12} sm={4} md={3} key={i}>
                                <ScrollAnimation animateIn="zoomIn">
                                    <Paper >
                                        <Card boxShadow={10}
                                            className={classes.root}
                                            component={Link}

                                            to={`/cites/${item.countryCode}/${item.isoCode}/${item.id}`}>

                                            <CardActionArea>
                                                <CardMedia>
                                                    <Box className={classes.box}>
                                                        <img className={classes.img} src={item.src} />
                                                        <Box className={classes.boxContent}>
                                                            <Typography className={classes.title}>{item.name}</Typography>
                                                            <span className={classes.post}>Total Cities:{GetCitiesOfState("US", item.isoCode).length}</span>
                                                        </Box>
                                                        <ul className={classes.icon}>
                                                            <li className={classes.li}><Typography variant="body2" className={classes.a} ><b>Population: {item.pop}</b></Typography>
                                                            </li>
                                                            <li className={classes.li}> <Typography variant="body2" className={classes.a} ><b>Area: {item.area}</b></Typography>
                                                            </li>
                                                        </ul>
                                                    </Box>
                                                </CardMedia>
                                                <CardContent>
                                                    <Typography gutterBottom variant="h6" component="h6">
                                                        <b> {item.name}</b>
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </Paper>
                                </ScrollAnimation>
                            </Grid>

                        )
                }
            </Grid>
            {visible < states.length && <Container maxWidth="xs" className={classes.LoadMoreCities}>
                <Button className={classes.loadMorebtn} onClick={LoadMoreStateHandler} fullWidth>Load More States</Button>
            </Container>}
        </>
    )
}

export default Cards;
